import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _SourceName;
/** enums */
export var SourceType;
(function (SourceType) {
  SourceType["BOOK"] = "book";
  SourceType["CHAPTER"] = "chapter";
  SourceType["DIGITAL_FILE"] = "digital";
  SourceType["DIGITAL_IMAGE"] = "image";
  SourceType["DISSERTATION"] = "dissertation";
  SourceType["DISSERTATION_ABSTRACT"] = "dissertationabstract";
  SourceType["FILM_ONLINE_VIDEO"] = "film";
  SourceType["GOVERNMENT_PUBLICATION"] = "govt";
  SourceType["JOURNAL"] = "journal";
  SourceType["ONLINE_DATABASE"] = "database";
  SourceType["REVIEW"] = "review";
  SourceType["EDITORIAL"] = "editorial";
  SourceType["THESIS"] = "thesis";
  SourceType["TV_RADIO"] = "tv";
  SourceType["MAGAZINE"] = "magazine";
  SourceType["NEWSPAPER"] = "newspaper";
  SourceType["MICROFORM"] = "microform";
  SourceType["WEBSITE"] = "website";
  SourceType["INTRODUCTION"] = "introduction";
  SourceType["PHOTO"] = "photo";
  SourceType["BLOG"] = "blog";
  SourceType["INTERVIEW"] = "interview";
  SourceType["COURTCASE"] = "courtcase";
  SourceType["PRESS"] = "press";
  SourceType["REPORT"] = "report";
  SourceType["ADVERTISEMENT"] = "advertisement";
  SourceType["SCHOLARLY_PROJECT"] = "scholarlyproject";
  SourceType["LECTURE"] = "lecture";
  SourceType["MULTIVOLUME"] = "multivolume";
  SourceType["MUSICAL_RECORDING"] = "musicalrecording";
  SourceType["BROCHURE"] = "brochure";
  SourceType["LETTER"] = "letter";
  SourceType["BIBLE"] = "bible";
  SourceType["PAINTING"] = "painting";
  SourceType["MISCELLANEOUS"] = "miscellaneous";
  SourceType["CONFERENCE"] = "conference";
  SourceType["CARTOON"] = "cartoon";
  SourceType["CONGRESS"] = "congress";
  SourceType["DICTIONARY"] = "dictionary";
  SourceType["ENCYCLOPEDIA"] = "encyclopedia";
  SourceType["EMAIL"] = "email";
  SourceType["EXECUTIVE_ORDER"] = "executiveorder";
  SourceType["FEDERAL_BILL"] = "fedbill";
  SourceType["FEDERAL_REPORT"] = "fedreport";
  SourceType["FEDERAL_RULE"] = "fedrule";
  SourceType["MAILING_LIST"] = "mailinglist";
  SourceType["MAP"] = "map";
  SourceType["NEWSGROUP"] = "newsgroup";
  SourceType["NEWSLETTER"] = "newsletter";
  SourceType["FEDERAL_TESTIMONY"] = "testimony";
  SourceType["FEDERAL_STATUTE"] = "statute";
  SourceType["PATENT"] = "patent";
  SourceType["PAMPHLET"] = "pamphlet";
  SourceType["RAW_DATA"] = "rawdata";
  SourceType["PERFORMANCE"] = "performance";
  SourceType["WRITE_PASTE"] = "custom";
  SourceType["MANUSCRIPT"] = "manuscript";
  SourceType["SOFTWARE"] = "software";
  SourceType["REPRINTED_WORK"] = "collection";
})(SourceType || (SourceType = {}));
export var SourceName = (_SourceName = {}, _defineProperty(_SourceName, SourceType.BOOK, 'book'), _defineProperty(_SourceName, SourceType.CHAPTER, 'chapter'), _defineProperty(_SourceName, SourceType.DIGITAL_FILE, 'digital file'), _defineProperty(_SourceName, SourceType.DIGITAL_IMAGE, 'digital image'), _defineProperty(_SourceName, SourceType.DISSERTATION, 'dissertation'), _defineProperty(_SourceName, SourceType.DISSERTATION_ABSTRACT, 'dissertation abstract'), _defineProperty(_SourceName, SourceType.FILM_ONLINE_VIDEO, 'film/online video'), _defineProperty(_SourceName, SourceType.GOVERNMENT_PUBLICATION, 'government publication'), _defineProperty(_SourceName, SourceType.JOURNAL, 'journal'), _defineProperty(_SourceName, SourceType.ONLINE_DATABASE, 'online database'), _defineProperty(_SourceName, SourceType.REVIEW, 'review'), _defineProperty(_SourceName, SourceType.THESIS, 'thesis'), _defineProperty(_SourceName, SourceType.TV_RADIO, 'tv/radio'), _defineProperty(_SourceName, SourceType.WEBSITE, 'website'), _defineProperty(_SourceName, SourceType.MAGAZINE, 'magazine'), _defineProperty(_SourceName, SourceType.MICROFORM, 'microform'), _defineProperty(_SourceName, SourceType.NEWSPAPER, 'newspaper'), _defineProperty(_SourceName, SourceType.INTRODUCTION, 'introduction'), _defineProperty(_SourceName, SourceType.INTERVIEW, 'interview'), _defineProperty(_SourceName, SourceType.EDITORIAL, 'editorial'), _defineProperty(_SourceName, SourceType.BLOG, 'blog'), _defineProperty(_SourceName, SourceType.PHOTO, 'photo'), _defineProperty(_SourceName, SourceType.SCHOLARLY_PROJECT, 'scholarly project'), _defineProperty(_SourceName, SourceType.COURTCASE, 'courtcase'), _defineProperty(_SourceName, SourceType.LECTURE, 'lecture'), _defineProperty(_SourceName, SourceType.PRESS, 'press'), _defineProperty(_SourceName, SourceType.REPORT, 'report'), _defineProperty(_SourceName, SourceType.ADVERTISEMENT, 'advertisement'), _defineProperty(_SourceName, SourceType.MULTIVOLUME, 'multivolume'), _defineProperty(_SourceName, SourceType.MUSICAL_RECORDING, 'musical recording'), _defineProperty(_SourceName, SourceType.BROCHURE, 'brochure'), _defineProperty(_SourceName, SourceType.LETTER, 'letter'), _defineProperty(_SourceName, SourceType.BIBLE, 'bible'), _defineProperty(_SourceName, SourceType.PAINTING, 'painting'), _defineProperty(_SourceName, SourceType.MISCELLANEOUS, 'miscellaneous'), _defineProperty(_SourceName, SourceType.CONFERENCE, 'conference'), _defineProperty(_SourceName, SourceType.CARTOON, 'cartoon'), _defineProperty(_SourceName, SourceType.CONGRESS, 'congress'), _defineProperty(_SourceName, SourceType.DICTIONARY, 'dictionary'), _defineProperty(_SourceName, SourceType.ENCYCLOPEDIA, 'encyclopedia'), _defineProperty(_SourceName, SourceType.EMAIL, 'email'), _defineProperty(_SourceName, SourceType.EXECUTIVE_ORDER, 'executive order'), _defineProperty(_SourceName, SourceType.FEDERAL_BILL, 'federal bill'), _defineProperty(_SourceName, SourceType.FEDERAL_REPORT, 'federal report'), _defineProperty(_SourceName, SourceType.FEDERAL_RULE, 'federal rule'), _defineProperty(_SourceName, SourceType.MAILING_LIST, 'mailing list'), _defineProperty(_SourceName, SourceType.MAP, 'map'), _defineProperty(_SourceName, SourceType.NEWSGROUP, 'newsgroup'), _defineProperty(_SourceName, SourceType.NEWSLETTER, 'newsletter'), _defineProperty(_SourceName, SourceType.FEDERAL_TESTIMONY, 'federal testimony'), _defineProperty(_SourceName, SourceType.FEDERAL_STATUTE, 'federal statute'), _defineProperty(_SourceName, SourceType.PATENT, 'patent'), _defineProperty(_SourceName, SourceType.PAMPHLET, 'pamphlet'), _defineProperty(_SourceName, SourceType.RAW_DATA, 'raw data'), _defineProperty(_SourceName, SourceType.PERFORMANCE, 'performance'), _defineProperty(_SourceName, SourceType.WRITE_PASTE, 'write/paste citation'), _defineProperty(_SourceName, SourceType.MANUSCRIPT, 'manuscript'), _defineProperty(_SourceName, SourceType.SOFTWARE, 'software'), _defineProperty(_SourceName, SourceType.REPRINTED_WORK, 'reprinted work'), _SourceName);
export var CitationPubTypeEnum;
(function (CitationPubTypeEnum) {
  CitationPubTypeEnum["PUBJOURNAL"] = "pubjournal";
  CitationPubTypeEnum["PUBNONPERIODICAL"] = "pubnonperiodical";
  CitationPubTypeEnum["PUBONLINE"] = "pubonline";
  CitationPubTypeEnum["PUBDATABASE"] = "pubdatabase";
  CitationPubTypeEnum["PUBREPRINT"] = "pubreprint";
  CitationPubTypeEnum["PUBABSTRACTSJOURNAL"] = "pubabstractsjournal";
  CitationPubTypeEnum["PUBNONE"] = "";
  CitationPubTypeEnum["PUBMAGAZINE"] = "pubmagazine";
  CitationPubTypeEnum["PUBNEWSPAPER"] = "pubnewspaper";
  CitationPubTypeEnum["PUBOTHER"] = "pubother";
  CitationPubTypeEnum["PUBMICROFILM"] = "pubmicrofilm";
})(CitationPubTypeEnum || (CitationPubTypeEnum = {}));
export var PubMainTypeEnum;
(function (PubMainTypeEnum) {
  PubMainTypeEnum["PUB_FEDERAL"] = "pubfederal";
  PubMainTypeEnum["PUB_FILM"] = "pubfilm";
  PubMainTypeEnum["PUB_JOURNAL"] = "pubjournal";
  PubMainTypeEnum["PUB_MAGAZINE"] = "pubmagazine";
  PubMainTypeEnum["PUB_NEWSPAPER"] = "pubnewspaper";
  PubMainTypeEnum["PUB_NONE"] = "";
  PubMainTypeEnum["PUB_NONPERIODICAL"] = "pubnonperiodical";
  PubMainTypeEnum["PUB_ONLINE"] = "pubonline";
  PubMainTypeEnum["PUB_OTHER"] = "pubother";
  PubMainTypeEnum["PUB_TVR"] = "pubtvr";
  PubMainTypeEnum["PUB_DATABASE"] = "pubdatabase";
  PubMainTypeEnum["PUB_LIVE"] = "publive";
})(PubMainTypeEnum || (PubMainTypeEnum = {}));
export var PubSuffixTypeEnum;
(function (PubSuffixTypeEnum) {
  PubSuffixTypeEnum["PUB_ABSTRACTS_JOURNAL"] = "pubabstractsjournal";
  PubSuffixTypeEnum["PUB_DATABASE"] = "pubdatabase";
  PubSuffixTypeEnum["PUB_NONE"] = "";
  PubSuffixTypeEnum["PUB_ONLINE"] = "pubonline";
  PubSuffixTypeEnum["PUB_OTHER"] = "pubother";
  PubSuffixTypeEnum["PUB_REPRINT"] = "pubreprint";
  PubSuffixTypeEnum["PUB_NONPERIODICAL"] = "pubnonperiodical";
  PubSuffixTypeEnum["PUB_MAGAZINE"] = "pubmagazine";
  PubSuffixTypeEnum["PUB_NEWSPAPER"] = "pubnewspaper";
  PubSuffixTypeEnum["PUB_MICROFILM"] = "pubmicrofilm";
})(PubSuffixTypeEnum || (PubSuffixTypeEnum = {}));
export var FormMode;
(function (FormMode) {
  FormMode[FormMode["NEW"] = 0] = "NEW";
  FormMode[FormMode["EDIT"] = 1] = "EDIT";
})(FormMode || (FormMode = {}));
export var BackButtonTexts;

/** writing form prop interface */
(function (BackButtonTexts) {
  BackButtonTexts["BACK_TO_REVIEW"] = "BACK_TO_REVIEW";
  BackButtonTexts["BACK_TO_SEARCH"] = "BACK_TO_SEARCH";
  BackButtonTexts["BACK_TO_RESULTS"] = "BACK_TO_RESULTS";
  BackButtonTexts["CANCEL"] = "CANCEL";
  BackButtonTexts["BACK_TO_CITATION_LIST"] = "BACK_TO_CITATION_LIST";
})(BackButtonTexts || (BackButtonTexts = {}));
/** citation object related type declarartions */
/** base data reltaed types */
/** source specific data types */
/** pub data types */